export * from "../../types"
import { omnia } from "@omnia/exports/omnia"

import { DatalayersMap } from "@omnia/shared/layers/datalayersMap"
import { IDatalayerMapDependencies } from "./omnia"
import { IFieldsMapContainerOptions } from "./omnia"
import { IDataLayerType } from "./omnia"
import { SharedFieldsService } from "./omnia"
import { IFieldsMap } from "./omnia"


export const {
    convertDatesToJsonUtc,
    createLookup,
    crops,
    defineComponent,
    defineDirective,
    handleApiError,
    isAdmin,
    isArrayEmpty,
    isNumber,
    isUndefinedOrNull,
    labels,
    models,
    omniaResolve,
    OmniaService,
    param,
    setDates,
    shell,
    str,
    sum,
    createMap,
    groupBy,
    getDistinctValues,
    createIndex,
    except,
    compareArrays,
    isObject,
    selectMany,
    isArray,
    isUndefined,
    arrayMax,
    arrayMin,
    isDate,

    fields: {
        getCropColor,
        getCropCssColor
    },

    color: {
        changeLuminosity,
        colorToCss,
        getWhiteBlackForegroundFromBackgroundColor
    },

    manure: {
        getManureTypeColor,
        filterAvailableTypes,
        setupManureTypesForRegion
    },

    stocks: {
        manureStockAnalysisFields,
        manureStockTotalFields
    },

    react: {
        classes
    },

} = omnia

export { Module } from "@omnia/shared/shell/module"

export {
    OmniaModuleId,
    OmniaObjectType,
    LayerTypeId,
    LayerTypeGroupId,
    StockType,
    RegionId,
    CropId
} from "@omnia/shared/generated/enums"

export type FieldService = SharedFieldsService
export type FieldMap = IFieldsMap
export type LayerMapDependencies = IDatalayerMapDependencies
export type LayerType = IDataLayerType

export type LayerMapFactory = {
    (options?: IFieldsMapContainerOptions): DatalayersMap
    readonly dependencies: LayerMapDependencies
}

export {
    DatalayersMap as LayerMap
}